var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class WyreStormSw130Tx {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: 'GET SW',
                next: /HDMI 1|HDMI 2|USBC|No active source channel/i,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`GET SW_VERSION`, /EX.*\s+V([0-9a-f\.]+)/i, tags);
                return match[1];
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`GET SW`, /(HDMI 1|HDMI 2|USBC)|No active source channel/i, tags);
                if (match[1])
                    return match[1].replace(/\s+/g, '').toLowerCase();
                return this.state.videoMatrixRoutes.values[key];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`SET SW ${value}`, /(HDMI 1|HDMI 2|USBC)|parameter error/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 3000);
                if (match[1])
                    return match[1].replace(/\s+/g, '').toLowerCase();
                return this.state.videoMatrixRoutes.values[key];
            }),
        };
        // polling
        this.polls = [{ intervalMs: 4000, controls: ['videoMatrixRoutes'] }];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
WyreStormSw130Tx.driverType = 'socketDriver';
WyreStormSw130Tx.key = '-Ms1SDpZBhT5-yUlb2Zf';
WyreStormSw130Tx.baseSocketOptions = {};
WyreStormSw130Tx.socketOptions = [
    Object.assign(Object.assign({}, WyreStormSw130Tx.baseSocketOptions), { port: 4999 }),
];
